import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export type TCenterBoxProps = {
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const CenterBox = (props: TCenterBoxProps) => {
  const { children, className, onClick } = props
  return (
    <div
      className={twMerge('flex inset-0 items-center justify-center', className)}
      {...{ onClick }}
    >
      {children}
    </div>
  )
}
